let consumed = false;

/**
 * `true` si le document courant vient d'un rechargement navigateur (F5, ⌘R,
 * bouton « Recharger ») atterri sur l'URL courante — **une seule fois par
 * document**.
 *
 * Les appels suivants renvoient `false` : un rechargement ne concerne que la
 * page où il a eu lieu, pas celles ouvertes ensuite par navigation interne. Un
 * rechargement atterri sur une autre page (accueil → offre) est ignoré pour la
 * même raison.
 */
export function consumePageReload(): boolean {
  if (consumed || typeof window === 'undefined') return false;
  consumed = true;

  const [navigation] = (performance.getEntriesByType?.('navigation') ??
    []) as PerformanceNavigationTiming[];
  if (navigation?.type !== 'reload') return false;

  try {
    return new URL(navigation.name).pathname === window.location.pathname;
  } catch {
    return false;
  }
}

export function __resetPageReloadForTests(): void {
  consumed = false;
}
